import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
    setMobileMenuOpen(false);
  };

  if (!user) return null;

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link
          to={user.role === 'admin' ? '/admin/dashboard' : '/customer/dashboard'}
          className="navbar-brand"
          onClick={() => setMobileMenuOpen(false)}
        >
          <span className="brand-icon">🛡️</span>
          <span className="brand-text">R.K. Warranty</span>
        </Link>

        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={mobileMenuOpen ? 'open' : ''}></span>
          <span className={mobileMenuOpen ? 'open' : ''}></span>
          <span className={mobileMenuOpen ? 'open' : ''}></span>
        </button>

        <div className={`navbar-menu ${mobileMenuOpen ? 'open' : ''}`}>
          {user.role === 'customer' ? (
            <>
              <Link
                to="/customer/dashboard"
                className={isActive('/customer/dashboard') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                📊 Dashboard
              </Link>
              <Link
                to="/customer/activate-warranty"
                className={isActive('/customer/activate-warranty') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                ➕ Activate Warranty
              </Link>
              <Link
                to="/customer/credits"
                className={isActive('/customer/credits') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                💰 Credits
              </Link>
            </>
          ) : (
            <>
              <Link
                to="/admin/dashboard"
                className={isActive('/admin/dashboard') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                📊 Dashboard
              </Link>
              <Link
                to="/admin/warranties"
                className={isActive('/admin/warranties') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                📦 Warranties
              </Link>
              <Link
                to="/admin/claims"
                className={isActive('/admin/claims') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                📋 Claims
              </Link>
              <Link
                to="/admin/credits"
                className={isActive('/admin/credits') ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                💰 Credits
              </Link>
            </>
          )}
          <div className="navbar-user-section">
            <span className="navbar-user">
              📱 {user.mobile}
            </span>
            <button onClick={handleLogout} className="btn-logout">
              🚪 Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

